<template>
  <div class="app-wrapper bg-white h-100">
    <div class="app-main">
      <div class="app-content p-0">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1 w-100 d-flex align-items-center">
            <div class="container-fluid">
              <div class="row" style="height: 100vh;">
                <!-- <div class="col-md-6 pl-0 d-none d-sm-flex align-items-center hide-image">
                  <div class="wrap" :style="wrapStyle">
                    <img
                      src="@/assets/img/daftar.jpg"
                      alt="register izidok"
                      :style="wrapImgStyle"
                    />
                  </div>
                </div> -->
                <div class="col-md-6 col-sm-0 background-image"></div>
                <!-- <div class="col-md-6 d-flex justify-content-center align-self-center" :class="windowWidth ? 'content-register-right' : ''"> -->
                <div
                  class="col-md-6 d-flex justify-content-center align-self-center"
                >
                  <div
                    class="col-sm-10 mt-2"
                    style="margin-left:auto;margin-right:auto"
                  >
                    <h4 class="font-weight-bold mb-3">
                      Daftarkan Faskes Anda Sekarang!
                    </h4>
                    <b-form @submit.prevent="submitForm">
                      <template v-if="formBasicData && formBasicData.length">
                        <b-form-group
                          v-for="form in formBasicData"
                          :key="form.tmpId"
                          :class="
                            form.name == 'info_izidok' ? '' : 'text-capitalize'
                          "
                          :invalid-feedback="
                            renderInvalidFeedback({
                              validationDesc: form['validation-desc']
                            })
                          "
                          :state="renderError({ error: form.error })"
                          style="margin-top:-7px;font-size:13px"
                        >
                          <template
                            v-if="
                              form.isType === 'password' ||
                                form.isType == 'password'
                            "
                          >
                            <label for="">{{ form.rawLabel }}</label>
                            <label for="" style="color:red"> *</label>
                            <b-input-group>
                              <b-input-group-text
                                slot="append"
                                class="border-left-0"
                                v-if="form.name == 'password'"
                                @click="switchVisibilityPassword"
                              >
                                <font-awesome-icon
                                  v-if="passwordVisible == false"
                                  icon="eye"
                                />
                                <font-awesome-icon v-else icon="eye-slash" />
                              </b-input-group-text>
                              <b-input-group-text
                                slot="append"
                                class="border-left-0"
                                v-if="form.name == 'password_confirmation'"
                                @click="switchVisibilityPasswordConfirmation"
                              >
                                <font-awesome-icon
                                  v-if="passwordVisible1 == false"
                                  icon="eye"
                                />
                                <font-awesome-icon v-else icon="eye-slash" />
                              </b-input-group-text>

                              <b-form-input
                                :type="form.type || 'text'"
                                class="border-right-0"
                                @input="
                                  setValue({
                                    rawLabel: form.rawLabel,
                                    label: form.label,
                                    $event,
                                    tmpId: form.tmpId
                                  })
                                "
                                :state="renderError({ error: form.error })"
                                :maxlength="form.maxlength"
                                :placeholder="form.placeholder"
                              />
                            </b-input-group>
                          </template>
                          <template v-else-if="form.type === 'select'">
                            <label for="">{{ form.rawLabel }}</label>
                            <label for="" style="color:red"> *</label>
                            <vue-select
                              v-model="formData.info_izidok"
                              :options="options"
                              class="info_izidok"
                              placeholder="Pilih salah satu dibawah ini"
                            />
                          </template>
                          <template
                            v-else-if="form.type === 'select_jenis_faskes'"
                          >
                            <label for="">{{ form.rawLabel }}</label>
                            <label for="" style="color:red"> *</label>
                            <vue-select
                              v-model="formData.jenis_faskes"
                              :options="options_jenis_faskes"
                              class="info_izidok"
                              style="width: 50%;"
                              placeholder="Pilih salah satu dibawah ini"
                            />
                          </template>
                          <template v-else-if="form.name == 'nomor_telp'">
                            <label for="id_no_telp">{{ form.rawLabel }}</label>
                            <label v-show="form.required" style="color:red"
                              >*</label
                            >
                            <b-form-input
                              id="id_no_telp"
                              @input="
                                setValue({
                                  rawLabel: form.rawLabel,
                                  label: form.label,
                                  $event,
                                  tmpId: form.tmpId
                                })
                              "
                              :state="renderError({ error: form.error })"
                              :placeholder="form.placeholder"
                              :maxlength="form.maxlength"
                              @keypress.native="numberOnly($event)"
                            />
                          </template>
                          <template v-else>
                            <label for="">{{ form.rawLabel }}</label>
                            <label
                              for=""
                              v-show="form.required"
                              style="color:red"
                            >
                              *</label
                            >
                            <b-form-input
                              @input="
                                setValue({
                                  rawLabel: form.rawLabel,
                                  label: form.label,
                                  $event,
                                  tmpId: form.tmpId
                                })
                              "
                              :state="renderError({ error: form.error })"
                              :placeholder="form.placeholder"
                              :maxlength="form.maxlength"
                            />
                          </template>
                        </b-form-group>
                      </template>
                      <!-- <div
                        class="col-md-12 p-2 mb-1"
                        style="height:auto;background-color:#c9defb"
                      >
                        <div class="row p-1">
                          <div class="col-sm-2 text-center">
                            <img
                              src="@/assets/img/diagnostic.png"
                              alt="register izidok klinik"
                              height="45"
                            />
                          </div>
                          <small
                            class=" col-sm-10 __text_klinik"
                            style="font-size:13px;margin-bottom:0px;color:blue;font-weight:600"
                            >Akun ini akan menjadi akun utama yang diakses oleh
                            penanggung jawab klinik pusat/manajemen klinik
                            pusat.</small
                          >
                        </div>
                      </div> -->
                      <div class="form-group" style="font-size:13px">
                        Dengan menekan tombol Daftar,
                        <span class="text-capitalize">Anda</span> setuju dengan
                        semua
                        <a href="https://izidok.id/privacy-note">
                          <span class="text-capitalize"
                            ><strong>syarat {{ "&" }} ketentuan </strong></span
                          >
                        </a>
                        serta
                        <a href="https://izidok.id/privacy-note">
                          <span class="text-capitalize"
                            ><strong>kebijakan privasi</strong></span
                          >
                        </a>
                        yang berlaku.
                      </div>
                      <button
                        type="submit"
                        class="btn btn-md btn-block text-capitalize mb-1"
                        style="background-color :#3F7EA7; color:white; border-radius : 10px;"
                      >
                        daftar
                      </button>
                      <div class="text-center mb-5 pb-5" style="margin-top:2px;">
                        Anda Sudah Memiliki Akun?
                        <router-link to="/login">
                          <span class="btn-wrapper--label">Masuk di sini</span>
                        </router-link>
                      </div>
                    </b-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faFileSignature,
  faComments,
  faEye,
  faEyeSlash,
  faEdit,
  faImage
} from "@fortawesome/free-solid-svg-icons";

import {
  required,
  minLength,
  maxLength,
  sameAs,
  email,
  numeric,
  alphaNum
} from "vuelidate/lib/validators";

library.add(
  faArrowLeft,
  faEye,
  faEyeSlash,
  faFileSignature,
  faImage,
  faComments,
  faEdit
);
export default {
  components: {
    "vue-select": () => import("@/components/VueSelectClearable.vue")
  },
  data() {
    return {
      windowHeight: 0,
      formBasicData: null,
      formData: null,
      validateEmail: false,
      passwordVisible: false,
      passwordVisible1: false,
      options: [],
      options_jenis_faskes: [
        { value: 1, label: "Klinik" },
        { value: 2, label: "Dokter Praktik Mandiri" },
        { value: 3, label: "Bidan Praktik Mandiri" }
      ]
    };
  },
  mounted() {
    this.getInfoIzidok()
    this.formBasicData = this.setFormBasicData();
    this.setFormData();
    this.windowHeight = window.innerHeight;
    this.$nextTick(() => {
      window.addEventListener("resize", e => {
        this.windowHeight = window.innerHeight;
      });
    });
    this.isTPMB();
    this.resizeWidth();
  },
  validations() {
    return {
      formData: {
        email: {
          required,
          email,
          maxLength: maxLength(50),
          verifyEmail(val) {
            const { required: re, email: em } = this.$v.formData.email;
            if (val === "" || !re || !em) return true;

            return new Promise((resolve, reject) => {
              this.$axios
                .get(`email/faskes/verify?email=${val}`)
                .then(res => {
                  const {
                    data: { status, message }
                  } = res;

                  resolve(status);
                })
                .catch(err => {
                  if (err.response) {
                    const x = err.response.data;
                    if (x && x.email) {
                      resolve(false);
                    }
                  } else {
                    resolve(true);
                  }
                })
                .finally(() => {
                  const x = "email";
                  this.triggerValidation({
                    label: x,
                    $v: this.$v,
                    $vm: this,
                    rawLabel: x
                  });
                });
            });
          }
        },
        nama_faskes: {
          required,
          maxLength: maxLength(200)
        },
        nama_lengkap: {
          required,
          maxLength: maxLength(50)
        },
        info_izidok: {
          required
        },
        kode_referral: {
          alphaNum
        },
        "no._handphone": {
          numeric,
          required,
          maxLength: maxLength(15),
          minLength: minLength(9),

          verifyPhone(val) {
            if (this.timeVerifyPhone) clearTimeout(this.timeVerifyPhone);

            return new Promise((resolve, reject) => {
              this.timeVerifyPhone = setTimeout(() => {
                const { required: re } = this.$v.formData["no._handphone"];
                if (val === "" || !re) resolve(true);
                this.$axios
                  .get(`phone/verify?nomor_telp=${val}`)
                  .then(res => {
                    const {
                      data: { status, message }
                    } = res;
                    resolve(status);
                  })
                  .catch(err => {
                    if (err.response) {
                      const x = err.response.data;
                      if (x && x.nomor_telp) {
                        resolve(false);
                      }
                    } else {
                      resolve(true);
                    }
                  })
                  .finally(() => {
                    const x = "no._handphone";
                    this.triggerValidation({
                      label: x,
                      $v: this.$v,
                      $vm: this
                    });
                    resolve(true);
                  });
              }, 450);
            });
          }
        },
        password: {
          required,
          maxLength: maxLength(15),
          verifyPassword(val) {
            if (val.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/)) {
              return true;
            } else {
              return false;
            }
          }
        },
        konfirmasi_password: {
          required,
          sameAsPassword: sameAs("password"),
          minLength: minLength(6),
          maxLength: maxLength(15)
        },
        jenis_faskes: {
          required
        }
      }
    };
  },
  watch: {
    "formData.info_izidok"() {
      let val = this.formData.info_izidok;
      if (val != null || val != "") this.formBasicData[7].error = false;
    },
    "formData.jenis_faskes"() {
      let val = this.formData.jenis_faskes.value;
      if (val != null || val != "") this.formBasicData[0].error = false;
    }
  },
  computed: {
    wrapStyle() {
      return {
        height: this.windowHeight + "px"
      };
    },
    wrapImgStyle() {
      return {
        "max-height": this.windowHeight + "px"
      };
    },
    windowWidth() {
      return window.innerWidth > 770 ? true : false;
    }
  },
  methods: {
    numberOnly(event) {
      const key = String.fromCharCode(event.keyCode);
      if (!/^\d+$/.test(key)) {
        event.preventDefault();
      }
    },
    async addKlinik() {
      try {
        const { formData, formBasicData } = this;

        const tmpPostData = formBasicData.reduce((obj, item) => {
          const { label, name } = item;
          if (name == "info_izidok") obj[name] = formData[label].value;
          else if (name == "jenis_faskes") obj[name] = formData[label].value;
          else obj[name] = formData[label];
          return obj;
        }, {});

        const postData = {
          ...tmpPostData,
          tipe_faskes: this.formData.jenis_faskes.value,
          is_bidan: this.formData.jenis_faskes.value == 3,
          nama_klinik: this.formData.nama_faskes

        };

        const res = await this.$axios.post(`klinik`, postData);
        const { status, data, message } = res.data;

        if (status) {
          this.$router.push({
            name: "verification-process",
            params: {
              email: postData.email,
              user_id: data.user_id,
              created_at: data.created_at
              // tipe_faskes: 1
            }
          });
        } else {
          let match = message.match(/(email|nomor_telp) is already in used/);
          if (match) {
            this.$swal({
              title: `${startCase(match[1])} Tidak Dapat Digunakan`,
              text: `${startCase(match[1])} telah terdaftar. Silakan gunakan ${
                match[1]
              } lain untuk melakukan registrasi!`,
              type: "error"
            });
          }
        }
      } catch (err) {
        // console.log(err);
      }
    },
    switchVisibilityPassword() {
      this.formBasicData[5].type == "password"
        ? (this.formBasicData[5].type = "text")
        : (this.formBasicData[5].type = "password");
      if (this.formBasicData[5].type == "text") {
        this.passwordVisible = true;
      } else if (this.formBasicData[5].type == "password") {
        this.passwordVisible = false;
      }
    },
    switchVisibilityPasswordConfirmation() {
      this.formBasicData[6].type == "password"
        ? (this.formBasicData[6].type = "text")
        : (this.formBasicData[6].type = "password");
      if (this.formBasicData[6].type == "text") {
        this.passwordVisible1 = true;
      } else if (this.formBasicData[6].type == "password") {
        this.passwordVisible1 = false;
      }
    },
    submitForm() {
      const tmp = this.formBasicData.filter(item => item.label);

      let requiredFieldFilled = 0;

      tmp.forEach((item) => {
        if (item.name == "kode_referral") return;

        if (item.error !== null && !item.error) {
          requiredFieldFilled++;
        }
      });
      
      if (requiredFieldFilled == 8) {
        this.addKlinik();
      } else {
        tmp.map(item => {
          this.triggerValidation({
            label: item.label,
            $v: this.$v,
            $vm: this
          });
        });
      }
    },
    setFormData() {
      this.formData = this.setFormBasicData({
        noFilter: false
      }).reduce((arr, val) => {
        arr[val.label.split(" ").join("_")] = "";
        return arr;
      }, {});
    },
    setFormBasicData({ noFilter = true, showHidden = false } = {}) {
      const tmp = [
        {
          label: "jenis faskes",
          type: "select_jenis_faskes",
          rawLabel: "Jenis Faskes",
          isType: "select_jenis_faskes",
          name: "jenis_faskes",
          required: true
        },
        {
          label: "nama faskes",
          placeholder: "Masukkan nama Faskes",
          name: "nama_faskes",
          maxlength: 200,
          rawLabel: "Nama Faskes",
          required: true
        },
        {
          label: "nama lengkap",
          placeholder: "Masukkan nama lengkap Anda",
          name: "nama_lengkap",
          maxlength: 50,
          rawLabel: "Nama Lengkap",
          required: true
        },
        {
          label: "email",
          rawLabel: "alamat email",
          placeholder: "Masukkan alamat email",
          type: "email",
          name: "email",
          maxlength: 50,
          required: true
        },
        {
          label: "no. handphone",
          placeholder: "Masukkan No. Handphone Anda",
          name: "nomor_telp",
          maxlength: 15,
          rawLabel: "no. handphone",
          required: true
        },
        {
          label: "password",
          placeholder: "Masukkan password Anda",
          type: "password",
          isType: "password",
          name: "password",
          rawLabel: "password",
          maxlength: 15,
          required: true
        },
        {
          label: "konfirmasi password",
          placeholder: "Masukkan password Anda sekali lagi",
          type: "password",
          isType: "password",
          name: "password_confirmation",
          rawLabel: "konfirmasi password",
          maxlength: 15,
          required: true
        },
        {
          label: "info izidok",
          type: "select",
          rawLabel: "Dari mana Anda mengetahui tentang izidok?",
          isType: "select",
          name: "info_izidok",
          required: true
        },
        {
          label: "kode_referral",
          type: "text",
          rawLabel: "Kode Referral",
          isType: "text",
          name: "kode_referral",
          required: false,
          placeholder: "Masukkan kode Refferal"
        }
      ].map((item, index) => ({
        ...item,
        label: item.label.split(" ").join("_"),
        tmpId: index,
        error: null,
        placeholder: item.placeholder,
        rawLabel: item.rawLabel
      }));

      return showHidden ? tmp : tmp.filter(item => !item.hide);
    },
    setValue({ label, rawLabel, $event = null } = {}) {
      const value = $event;
      this.formData[label] = value && value.trim();

      const confirms = ["password", "konfirmasi_password"];
      if (confirms.includes(label)) {
        confirms.forEach(item => {
          this.triggerValidation({
            label: item,
            $v: this.$v,
            $vm: this,
            rawLabel: item.split("_").join(" ")
          });
        });
      } else {
        this.triggerValidation({
          label,
          $v: this.$v,
          $vm: this,
          rawLabel
        });
      }
    },
    async getInfoIzidok() {
      try {
        const res = await this.$axios.get(`info_izidok`);
        const { status, data } = res.data;

        if (status) {
          this.options = data
        }
      } catch (err) {
        // console.log(err);
      }
    },
    isTPMB() {
      if (this.$route.query.as == 'tpmb'){
        this.formData.jenis_faskes = {
          value: 3,
          label: "Bidan Praktek Mandiri"
        };
        return true;
      }
    },
     eventHandlerOrientation() {
      let orientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
      if (orientation != this.orientation) {
        this.orientation = orientation;
        setTimeout(() => {
          this.resizeWidth();
        }, 500);
      }
    },
    resizeWidth() {
      document.getElementById("wdgt_wrapper").style.removeProperty("width");
    },
  },
  created() {
    window.addEventListener('resize', this.eventHandlerOrientation);
  },
  destroyed() {
    window.removeEventListener('resize', this.eventHandlerOrientation);
  },
};
</script>

<style scoped>
.background-image {
  background-image: url("./../../assets/img/daftar.jpg");
  background-size: cover; /* Cover the entire div with the background image */
  background-position: center; /* Center the background image */
}
.content-register-right {
  position: absolute;
  right: 0px;
  zoom: 80%;
}

.__text_klinik {
  padding-left: 0px;
}

@media only screen and (max-width: 856px) and (min-width: 300px) {
  .__text_klinik {
    padding-left: 20px;
  }
}

.img-banner-left {
  position: fixed;
}

.wrap {
  width: 100%;
  height: 100%;
  position: relative;
  display: inline-block;
  overflow: hidden;
  margin: 0;
}

.wrap img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  min-height: 100%;
  min-width: 100%;
  transform: translate(-50%, -50%);
}
</style>

<style>
.info_izidok
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
  font-size: 15px !important;
}
</style>
